/*
 * Filter Dropdown
 *
 * Interactive Product SubCategory dropdown
 * with screen takeover style.
 * This should include triggers of changing product filters state.
 **/

custom.filterDropdown = (() => {

  const dropdownClass = "filter-dropdown";
  const dropdownToggleClass = "filter-toggle";
  const dropdownTriggerClass = "js-filter-dropdown";
  const dropdownOpenClass = "js-filter-dropdown-open";
  const categoryActiveClass = "js-filter-dropdown-active";
  const categoryFilteredClass = "js-filter-dropdown-filtered";

  const $dropdown = $(`.${dropdownClass}`);
  const $toggler = $(`.${dropdownToggleClass}`);
  const $trigger = $(`.${dropdownTriggerClass}`);
  const $dropdownLinks = $(`.${dropdownClass}`).find('a');
  const $body = $('body');

  // string helper
  const titleCase = (str) => {
    if(!str) return false;
    return str.toLowerCase().split('-').map((word) => {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  }

  // helper
  const scrollToAnchor = () => {
    if ($("#collaboration-products").length) {
      const scrollY = $('#collaboration-products').offset().top;
      window.scrollTo({
        top: scrollY,
        behavior: 'smooth',
      });
    }
  }

  const bodyClassClose = () => {
    if($body.hasClass(dropdownOpenClass)) $body.removeClass(dropdownOpenClass);
  }

  const bodyClassHandler = () => {
    setPositionDropdown();
    if(!$body.hasClass(dropdownOpenClass)) {
      $body.addClass(dropdownOpenClass);
    } else {
      $body.removeClass(dropdownOpenClass);
    }
  }

  const setPositionDropdown = () => {
    $dropdown.find('ul').css({
      top: ($trigger.offset().top - $(window).scrollTop()) + $trigger.outerHeight(),
      left: $trigger.offset().left
    });
  }

  const backgroundClicked = event => {
    event.stopPropagation();
    if($(event.target).hasClass(dropdownClass)) bodyClassClose();
  }

  const resetFilter = () => {
    $.each($(`[data-filter-category-id]`), (index, el) => {
      $(el).removeClass(categoryActiveClass + ' ' + categoryFilteredClass);
    });
  }

  const switchHandler = event => {
    let category;
    let categoryName;

    if (event.type === 'load' && window.location.hash.length > 0) {
      // set category via page navigation to specific collab product category
      category = window.location.hash.split('#collaboration-')[1];
      categoryName = category == 'art' ? 'Wall Art' : titleCase(category);
      if (!category) return;
      scrollToAnchor();
    } else if (event.type === 'click') {
      // set category via filter dropdown
      const $el = $(event.target);
      category = $el.data('filter-category');
      categoryName = $el.text();
    }

    if(!category) return;
    event.preventDefault();
    bodyClassClose();
    resetFilter();

    $(`.${dropdownTriggerClass}`).text(categoryName);
    if(category == 'all') {
      $.each($(`[data-filter-category-id]`), (index, el) => {
        $(el).addClass(categoryActiveClass);
        $(`.${categoryActiveClass} .collection-card__thumbnails.slick-initialized.slick-slider`).slick('refresh');
      });
    } else {
      $(`[data-filter-category-id=${category}]`).addClass(categoryActiveClass + ' ' + categoryFilteredClass);
      $(`.${categoryActiveClass} .collection-card__thumbnails.slick-initialized.slick-slider`).slick('refresh');
    }
  }

  let init = () => {
    if($trigger.length > 0) {
      // Open & Close
      $trigger.on('click', bodyClassHandler);

      // Close
      $dropdown.on('click', backgroundClicked);
      $toggler.on('click', bodyClassClose);

      // Panel Switcher
      $dropdownLinks.on('click', switchHandler);

      // Re-purpose Switcher
      // when page navigated to a specific collab product category
      $(window).on('load', switchHandler);
    }
  }

  return {
    init
  };

})();

custom.filterDropdown.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/filter-dropdown.js